import React from "react";
import { Button } from "../components/ui/button";
import { Trash2, Pencil } from "lucide-react";

export function AdminTable({ columns, rows, onEdit, onDelete, testIdPrefix = "row" }) {
  return (
    <div className="rounded-2xl border border-foreground/10 overflow-hidden">
      <table className="w-full text-sm">
        <thead className="bg-[#F4EFE6] dark:bg-[#0F284B]">
          <tr>
            {columns.map((c) => (
              <th key={c.key} className="text-left px-4 py-3 font-semibold uppercase text-[10px] tracking-[0.2em]">{c.label}</th>
            ))}
            {(onEdit || onDelete) && <th className="px-4 py-3 w-32" />}
          </tr>
        </thead>
        <tbody>
          {rows.map((r, i) => (
            <tr key={r.id || i} data-testid={`${testIdPrefix}-${r.id || i}`} className="border-t border-foreground/10 hover:bg-foreground/5">
              {columns.map((c) => (
                <td key={c.key} className="px-4 py-3 align-middle">{c.render ? c.render(r) : r[c.key]}</td>
              ))}
              {(onEdit || onDelete) && (
                <td className="px-4 py-3">
                  <div className="flex justify-end gap-1">
                    {onEdit && (
                      <Button data-testid={`edit-${r.id}`} size="sm" variant="outline" className="rounded-full h-8 w-8 p-0" onClick={() => onEdit(r)}>
                        <Pencil className="w-3.5 h-3.5" />
                      </Button>
                    )}
                    {onDelete && (
                      <Button data-testid={`delete-${r.id}`} size="sm" variant="outline" className="rounded-full h-8 w-8 p-0 hover:bg-destructive/10" onClick={() => onDelete(r)}>
                        <Trash2 className="w-3.5 h-3.5" />
                      </Button>
                    )}
                  </div>
                </td>
              )}
            </tr>
          ))}
          {rows.length === 0 && (
            <tr><td colSpan={columns.length + 1} className="text-center py-8 text-foreground/50">No records yet.</td></tr>
          )}
        </tbody>
      </table>
    </div>
  );
}
